export default __webpack_public_path__ + "static/media/visionIcon.b437eecf.png";